/**
 * Check whether one element contains another. This effectively serves
 * as a polyfill for Node.contains, which only works on Elements in IE.
 */
var elementContains = function elementContains(outer, inner) {
  var compared = outer.compareDocumentPosition(inner); // eslint-disable-next-line no-bitwise

  return (compared & Node.DOCUMENT_POSITION_CONTAINED_BY) > 0;
};

export default elementContains;